<template>
  <li class="has-background-light">
    <h6 class="title is-6">Bundel: {{ bundle.name }}</h6>
    <h6 v-if="table" class="title is-6">Tabel: {{ table.name }}</h6>

    <p class="action content" v-html="action"></p>

    <p class="is-pulled-right">{{ process.done }} / {{ process.total }}</p>

    <progress
      class="progress is-small"
      :class="process.done === process.total ? 'is-success' : 'is-info'"
      :value="status"
      max="100">
      {{ status }}%
    </progress>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'process'
  ],
  computed: {
    ...mapGetters({
      tables: 'tables/tables',
      bundles: 'bundles/bundles',
      processes: 'processes/processes'
    }),
    table () {
      return this.tables.find(x => x.id === this.process.table_id)
    },
    action () {
      return this.actions[this.process.type]
    },
    bundle () {
      return this.bundles.find(x => x.id === this.process.bundle_id)
    },
    shortName () {
      return (this.table.name.length > this.cutoff) ? `${this.table.name.substring(0, this.cutoff)}...` : this.table.name
    },
    status () {
      return (this.process.done / this.process.total) * 100
    }
  },
  created () {
    this.$echo.channel(`process-state:${this.process.key}`).listen('ProcessChanged', (e) => {
      this.$store.commit('processes/UPDATE', { key: e.key, done: e.done })
    })
  },
  data () {
    return {
      cutoff: 25,
      actions: [
        'Regels genereren',
        'Regels importeren',
        'Regels verwijderen',
        'Regels wijzigen',
        'Bundel kopiëren <i class="fas fa-check"></i><br>Basislijst kopiëren <i class="fas fa-check"></i><br>Content kopiëren <i class="fas fa-check"></i><br>Tabeldata kopiëren ...'
      ]
    }
  }
}
</script>

<style scoped>
  h6, .action {
    margin-bottom: 0 !important;
  }

  li {
    margin-bottom: 15px;
    padding: 15px;
    border-radius: 5px;
  }

  li:last-child {
    margin-bottom: 0;
  }
</style>
